module.exports = __webpack_public_path__ + "img/music-work-icon9.e7956684.png";